<val-carte-dashboard [titre]="'dashboard.carte-repartition-statuts-vente.titre' | transloco" [colonnes]="6" [lignes]="2"
	[chargementEnCours]="chargementEnCours" [estEnErreur]="estEnErreur" [estVide]="estVide">

	<ng-template>
	@if (donnees)
	{
	<div class="chart-wrapper">
		<kendo-chart>
			<kendo-chart-series>
				<kendo-chart-series-item type="donut" [data]="donnees.thematiques" field="nombre"
					categoryField="libelle" colorField="couleurCode" [tooltip]="{ visible: true, format: '{0}' }">
				</kendo-chart-series-item>
			</kendo-chart-series>
		</kendo-chart>
	</div>
	}
	</ng-template>

</val-carte-dashboard>
